import { RootState } from 'store/rootTypes';

export const IncentiveSelector = (state: RootState) => state.Incentive;
